const styles = theme => ({
  dialogContainer: {
    maxWidth: '510px',
    width: '100%',
    margin: '0 auto',
    boxShadow: 'none'
  },
  dialogTitle: {
    '& h6': {
      fontFamily: 'Titillium-Regular, Helvetica Neue, sans-serif',
      fontSize: '18px',
      color: '#323233',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  dialogInputContainer: {
    padding: '0 24px 15px'
  },
  dialogInput: {
    marginBottom: '15px'
  },
  dialogButtonContainer: {
    paddingLeft: '10px',
    justifyContent:'flex-start',
    '& div': {
      display: 'block',
      width: '100%'
    },
    '& button': {
      fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
  marginBottom: '20px',
  [theme.breakpoints.down('xs')]: {
    width: 'calc(100% - 20px)'
  }
    }
  },
  dialogSubmitButton: {
    fontSize: '14px',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    textTransform: 'uppercase',
    marginBottom: '32px',
    height: '40px'
  },

  popupTitle: {
    '& h6': {
      fontSize: '22px',
      fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
      color: '#323233',
      paddingBottom: '8px',
      borderBottom: '1px solid #d8d8d8',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
   },
    '& span': {
      color: '#ff3f79'
    }
  },
  popupBuyerTitle: {
    '& h6': {
      fontSize: '26px',
      paddingBottom: '15px'
    }
  },
  gridRow: {
    width:'calc(510px - 48px)',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    },
    '& div': {
      marginBottom: '5px',
      [theme.breakpoints.down('xs')]: {
        paddingRight: '0'
      }
    }
  },
  fieldGridLeft: {
    paddingRight: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '0'
    }
  },
  fieldGridRight: {
    paddingLeft: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '0'
    }
  } 
})
export default styles
